export const environment = {
  production: false,
  appName: 'Seedio',
  apiUrl: 'https://fra.cloud.appwrite.io/v1',
  loginUrl: 'xxx',
  appwrite: {
    projectId: '68ab7d3200251582dfd4',
    databaseId: '67f2a8dd00048e7600ed',
    collectionIdProperties: '67f2ac3000218cb04d4e',
    collectionIdWallet: '67e945df000519e1cd7d',
    collectionIdWalletTransactions: '67e946270020e9dd6a58',
    collectionIdPortfolio: '6813b08f000bd5d38c6f',
    collectionIdMyProperties: '6813aeec0011826116d8',
    collectionIdCart: '67e945580035777f97d2',
    collectionIdBookmarks: '6813bbdb0005f9e4f252',
    imagesBucketId: '68389cf800199f0c81d1',
    functionIdBuyCart: '68c7132100226ef148e1',
  },
  googleMapsApiKey: 'AIzaSyDDzi9CFc_8LcgNpVPqNc_a8txrGNZVtS0',
  enableDebug: true,
};
